import { Outlet } from "react-router-dom";
import { useState } from "react";
import Sidebar from "../components/Sidebar/Sidebar";
import Header from "../components/Header/Header";
import "./Layout.css";

export default function Layout() {
    const [sidebarOpen, setSidebarOpen] = useState(true);

    const branch = JSON.parse(localStorage.getItem("branch"));

    return (
        <div className="layout">
            <Sidebar isOpen={sidebarOpen} />

            <div className="main">
                <Header
                    onToggleSidebar={() => setSidebarOpen(!sidebarOpen)}
                />

                <main className="content">
                    <Outlet />
                </main>
            </div>

        </div>
    );
}
